import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

const allowedOrigins = [
  'https://localhost:4200',
  'https://tp-qa-design-admin.tenproduct.com',
  'https://tp-staging-design-admin.tenproduct.com',
];
const type = 'ten-custom-style';

interface Message {
  type: 'ten-custom-style';
  message: { [key: string]: string };
}

@Injectable({ providedIn: 'root' })
export class PostMessageService {
  public readonly message$: Observable<any>;

  constructor() {
    this.message$ = fromEvent(window, 'message').pipe(
      filter((event: MessageEvent<Message>) => allowedOrigins.includes(event.origin) && event.data.type === type),
      map((event) => event.data.message)
    );
  }
}
